export const colors = {
  primary: {
    lightest: "magenta",
    lighter: "pink",
    light: "var(--color--base-bright-soft)",
    base: "var(--color--brand-38)",
    dark: "#f47d3c",
    darker: "#f37028",
    darkest: "#e55a0d"
  },
  error: {
    lightest: "#F2E3DB",
    light: "#E79888",
    base: "#F5775D",
    darker: "#F66346",
    darkest: "#F14723"
  },
  alert: {
    info: "#1F93FF",
    success: "#2AA92F",
    warning: "#FBC02D",
    danger: "#F45B5B"
  },

  "primary-lightest": "var(--color--brand-91)",
  "primary-lighter": "var(--color--brand-89)",
  "primary-light": "var(--color--brand-60)",
  "primary-dark": "var(--color--brand-38)",
  "primary-darker": "var(--color--brand-34)",
  "info-lighter": "var(--info-alert--background-color)",
  "info-dark": "var(--info-alert--text-color)",
  warning: "var(--warning-color)",
  "grey-0": "var(--color--neutral-050)",
  "grey-1": "var(--color--neutral-100)",
  "grey-2": "var(--color--neutral-200)",
  "grey-3": "var(--color--neutral-300)",
  "grey-4": "var(--color--neutral-400)",
  "grey-5": "var(--color--neutral-500)",
  "grey-6": "var(--color--neutral-600)",
  "grey-7": "var(--color--neutral-700)",
  "grey-8": "var(--color--neutral-800)",
  linkForeground: "var(--base-color)",
  separatorTertiary: "var(--pane--border-color)",
  highlight: "var(--color--neutral-100)"
}
